var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value < 0)?_c('i',{domProps:{"innerHTML":_vm._s(_vm.$icons.play_red)}}):(_vm.value > 0)?_c('i',{domProps:{"innerHTML":_vm._s(_vm.$icons.play_green)}}):_c('i',[_c('div',{staticClass:"h-3 w-3 rounded-full bg-gray-500"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }